import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'via-sku-feedback',
  templateUrl: './sku-feedback.component.html',
  styleUrls: ['./sku-feedback.component.scss']
})
export class SkuFeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
